import moment from "moment";
import qs from "query-string";
import ApiCall from "src/components/ApiCall";
import Button from "src/components/Button";
import Form from "src/components/tasks/TaskForm/Form";
import KeyValue from "src/components/KeyValue";
import ReadMore from "src/components/ReadMore";
import UserAvatars from "src/components/UserAvatars";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useAuth from "src/hooks/selectors/useAuth";

import AdvertiseTask from "src/components/tasks/TaskForm/elements/AdvertiseTask";
import { useTranslation } from "react-i18next";
import Switch from "src/components/form/Switch";
import FinancialSummary from "src/components/tasks/TaskForm/elements/FinancialSummary";
import useModules from "src/hooks/selectors/useModules";
import useTenant from "src/hooks/api/services/tenants/useTenant";
import { TaskFormOptions } from "src/components/tasks/TaskForm";
import SummaryWrapper from "src/components/tasks/TaskForm/elements/SummaryWrapper";

const SummaryForm = ({ hideButtons }: TaskFormOptions) => {
	const { t } = useTranslation("forms", {
		keyPrefix: "summary-form",
	});
	const auth = useAuth();
	const { task, actions, current } = useTaskForm();
	const { modules } = useModules();
	const isSameDate =
		moment(task.start_date).format() === moment(task.end_date).format();

	const avatarQuery = qs.stringify({
		"include[]": task.students,
	});
	const { tenant } = useTenant();

	// let total =
	// 	task.budget * students + task.budget * students * auth.service_rate;

	const advertiseTask =
		modules?.includes("pay-advertise-task") && !task.is_anonymous;

	// if (task.advertise_task) {
	// 	total = total + ADVERTISEMENTS_PRICE.tasks;
	// }
	// if (task.add_christmas_gift) {
	// 	total = total + CHRISTMAS_GIFT_PRICE;
	// }

	return (
		<Form
			{...{ hideButtons }}
			header={
				<div className="mb-4">
					<Button
						className="h-[38px]"
						type="gray"
						iconOnly
						onClick={() => actions.updateCurrent(current - 1)}
					>
						<i className="fas fa-arrow-left"></i>
					</Button>
				</div>
			}
			title={t("title")}
		>
			{() => (
				<>
					<div className="">
						<strong>{t("info.title")}</strong>
						<p className="mb-0">{t("info.description")}</p>
					</div>
					<SummaryWrapper title={task.title}>
						<ReadMore
							className="mb-0"
							text={task.description}
							length={120}
						/>
					</SummaryWrapper>
					{advertiseTask && (
						<SummaryWrapper>
							<AdvertiseTask
								{...{ task }}
								onChange={(value) => {
									actions.set({
										advertise_task: value,
									});
								}}
							/>
						</SummaryWrapper>
					)}
					{auth?.company?.promos?.includes("christmas_gift") && (
						<SummaryWrapper title={t("promo.christmas.title")}>
							<Switch
								value={task.add_christmas_gift}
								label={t("promo.christmas.label")}
								onChange={(value) =>
									actions.set({
										add_christmas_gift: value,
									})
								}
							/>
							<a
								target="_blank"
								className="underline mt-2"
								href={`${tenant?.urls?.public}/bedrijven/kerst-actie`}
								rel="noreferrer"
							>
								{t("promo.christmas.more")}
							</a>
						</SummaryWrapper>
					)}
					<FinancialSummary />

					<SummaryWrapper title={t("details.title")}>
						{!isSameDate && (
							<>
								<KeyValue.Small
									label={t("details.start-date")}
									text={moment(task.start_date).format(
										"D MMMM"
									)}
								/>
								{task.end_date && (
									<KeyValue.Small
										label={t("details.end-date")}
										text={moment(task.end_date).format(
											"D MMMM"
										)}
									/>
								)}
							</>
						)}
						{isSameDate && (
							<KeyValue.Small
								label={t("details.date")}
								text={moment(task.end_date).format("D MMMM")}
							/>
						)}
						{task.estimated_duration && (
							<KeyValue.Small
								label={t("details.estimated-duration")}
								text={`${Math.floor(
									task.estimated_duration
								)} ${t("details.estimated-duration-end")}`}
							/>
						)}
						{(task.invite_all || task.students?.length > 0) && (
							<KeyValue.Small
								label={t("details.invited")}
								text={
									task.invite_all ? (
										t("details.invited-all")
									) : (
										<>
											<ApiCall
												query={`/connections?${avatarQuery}`}
											>
												{(data, loading) => (
													<>
														{loading && (
															<span className="base-loader" />
														)}
														{!loading && (
															<UserAvatars
																users={data}
															/>
														)}
													</>
												)}
											</ApiCall>
										</>
									)
								}
							/>
						)}
					</SummaryWrapper>
				</>
			)}
		</Form>
	);
};

export default SummaryForm;
